class RainfallRepository {
  constructor(api) {
    this.api = api;
  }
  async show() {
    let raw = `
    SELECT * FROM CROP.RAINFALL
    ORDER BY TIME ASC;
  `;
    const rainfall = await this.api.sql({
      data: {
        sql: raw
      }
    });

    return rainfall[0];
  }
  async updateRainfallByTime({ FK_STATION, DATA }) {
    //Mapper to Persistence
    let clause = ``;
    let times = ``;

    DATA.map((raw, index) => {
      times += `"${raw.TIME}" ${index === DATA.length - 1 ? "" : ","}`;
      clause += ` WHEN TIME="${raw.TIME}" THEN ${raw.VALUE}`;
    });

    const raw = `UPDATE CROP.RAINFALL SET VALUE_INPUT= CASE
    ${clause}
    ELSE VALUE_INPUT
    END
    WHERE TIME IN (${times});`;
    //End of Mapper

    return await this.api.sql({
      data: {
        sql: raw
      }
    });
  }
  async save(data) {
    let {
      FK_STATION, //ID da estação
      TIME, //  YYYY/MM/DD HH:mm
      VALUE //PLUVIOMETRIA
    } = data;

    let raw = `
    INSERT INTO CROP.RAINFALL(FK_STATION,TIME,VALUE)
    VALUES(${FK_STATION},'${TIME}','${VALUE}');
    `;

    // const resp = await knex
    //   .insert({
    //     FK_STATION,
    //     TIME,
    //     VALUE
    //   })
    //   .into("RAINFALL");

    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    if (resp.length) {
      console.log(
        `[CRON] - Sucesso ao salvar dados da altura_pluviométrica diária da estação ${FK_STATION}`
      );
    }
    // console.log(`Sucesso ao salvar ${resp} na tabela ET0`)
    return resp;
  }

  async showRainfallByStationAndInterval({ FK_STATION, START, END }) {
    let raw = `
      SELECT FK_STATION, TIME, VALUE FROM CROP.RAINFALL as rainfall
      WHERE rainfall.FK_STATION = ${FK_STATION}
      AND rainfall.TIME >= '${START}'
      AND rainfall.TIME <= '${END}'
      ORDER BY rainfall.TIME ASC
      ;
    `;
    // const rainfall = await knex
    //   .select("FK_STATION", "TIME", "VALUE")
    //   .from("RAINFALL")
    //   .where({ FK_STATION })
    //   .andWhere("TIME", ">=", START)
    //   .andWhere("TIME", "<=", END)
    //   .orderBy("TIME", "asc")
    //   .timeout(60000, { cancel: true });

    const rainfall = await this.api.sql({
      data: {
        sql: raw
      }
    });

    return rainfall[0];
  }

  async savePrevData(values) {
    let raw =
      "INSERT INTO CROP.RAINFALL (FK_STATION,TIME,VALUE) VALUES" + values + ";";
    // const resp = await knex.raw(
    //   "INSERT INTO RAINFALL (`FK_STATION`,`TIME`,`VALUE`) VALUES " + marks,
    //   values
    // );

    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    if (resp[0].length) {
      console.log(
        `[CRON] - Sucesso ao salvar dados de precipitação de dias anteriores.`
      );
    }

    return resp[0];
  }

  async del(FK_STATION) {
    let raw = `
      DELETE FROM CROP.RAINFALL
      WHERE FK_STATION = ${FK_STATION};
    `;
    // const resp = await knex("RAINFALL")
    //   .where("FK_STATION", FK_STATION)
    //   .del();
    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });
    if (resp.length) {
      console.log(
        `[CRON] - Sucesso ao deletar precipitação da estação ${FK_STATION}.`
      );
    }

    return resp;
  }

  async deleteByInterval(FK_STATION, START, END) {
    let raw = `
      DELETE FROM CROP.RAINFALL
      WHERE FK_STATION = ${FK_STATION}
      AND TIME BETWEEN '${START}' AND '${END}';
    `;
    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    if (resp.length) {
      console.log(
        `[CRON] - Sucesso ao deletar rainfall da estação ${FK_STATION} por intervalo.`
      );
    }

    return resp;
  }

  async showRainfallByTime(TIME) {
    let raw = `
    SELECT * FROM CROP.RAINFALL
    WHERE TIME = '${TIME}'
    ORDER BY TIME ASC;
    `;
    // const rainfalls = await knex
    //   .select("*")
    //   .from("RAINFALL")
    //   .where("TIME", TIME);

    const rainfalls = await this.api.sql({
      data: {
        sql: raw
      }
    });

    if (rainfalls && rainfalls[0].length) {
      return rainfalls[0][0];
    }
    return;
  }
  async getRainfallByInterval(START, END) {
    let raw = `
      SELECT ID,TIME, VALUE FROM CROP.RAINFALL
      WHERE TIME BETWEEN '${START}' AND '${END}'
      ORDER BY TIME ASC;
    `;

    const rainfall = await this.api.sql({
      data: {
        sql: raw
      }
    });

    return rainfall[0];
  }
  async getRainfallSinceFirstLog(START) {
    let raw = `
      SELECT DISTINCT TIME,VALUE FROM (SELECT
        TIME,
        VALUE
      FROM
        CROP.RAINFALL as rainfall
        ) AS RAINFALLs
      WHERE RAINFALLs.TIME >= '${START}'
      ORDER BY TIME ASC;
    `;

    const rainfall = await this.api.sql({
      data: {
        sql: raw
      }
    });

    return rainfall;
  }
}
export { RainfallRepository };
